module.exports = __webpack_public_path__ + "static/sf-transrobotics-extended-bold-italic-6e1ab0118a470b2a5e16b5e9ebac55bd.ttf";